module.exports = {
    /**
    * Adds keyboard accessibility to the user account popin trigger.
    * Listens for the "Enter" key on elements with the ".js-user-popin-trigger" class,
    * and if the account popin is not already shown, prevents the default action and
    * triggers the mouseenter event to open the popin.
    *
    * @function
    * @returns {void}
    */
    accountKeyboardAccessibility: function () {
        $(".js-user-popin-trigger").on("keydown", function(e) {
            if (e.key === "Enter") {
                if (!$(".js-account-popin").hasClass("show")) {
                    e.preventDefault();
                    $(this).trigger("mouseenter");
                }
            }
        });
    }
};
